import { SubstituteType, TextKey } from '@mews-commander/enums';
import { LOWER_BOUND, MAX_DECIMAL_SIZE, UPPER_BOUND } from './constants';

export const JAVASCRIPT_DECIMAL_SEPARATOR = '.';

const unformattedNumberRegex = new RegExp(
    `^(0|([1-9]+\\d*))(\\${JAVASCRIPT_DECIMAL_SEPARATOR}\\d{0,${MAX_DECIMAL_SIZE}})?$`
);

const transformNumberToString = (number: $TSFixMe) => (typeof number === 'number' ? `${number}` : number);

export const formatExponential = (number: $TSFixMe) => {
    const numberString = transformNumberToString(number);
    if (numberString.split(/[eE]/).length > 1) {
        return `${Number(numberString).toFixed(MAX_DECIMAL_SIZE)}`;
    }
    return numberString;
};

export const validateConversionValue = (unformattedNumberValue: $TSFixMe) => {
    const computedNumber = 1 / unformattedNumberValue;

    if (unformattedNumberValue < LOWER_BOUND) {
        return [
            {
                textKey: TextKey.ValidateNumberLowerBound,
                substitutesToFormat: [
                    { value: formatExponential(LOWER_BOUND), name: 'lowerBound', type: SubstituteType.Number },
                ],
            },
        ];
    }

    if (computedNumber < LOWER_BOUND) {
        return [
            {
                textKey: TextKey.ValidateNumberUpperBound,
                substitutesToFormat: [
                    { value: formatExponential(UPPER_BOUND), name: 'upperBound', type: SubstituteType.Number },
                ],
            },
        ];
    }

    if (!unformattedNumberRegex.test(unformattedNumberValue)) {
        return [{ textKey: TextKey.ValidateFormattedNumber }];
    }
};
